import { ArrowIcon } from '@modusign/design-system';
import { useDispatch } from 'react-redux';

import CenterLoadingSpinner from '@app/components/CenterLoadingSpinner';
import useDeposit from '@app/features/payment/hooks/useDeposit';
import useDepositTransactions from '@app/features/payment/hooks/useTransactions';
import { recordGTMEvent } from '@app/store/analytics/actions';
import { modalClose } from '@app/store/modal/actions';

import DepositTransactionList from './DepositTransactionList';

import './DepositTransactionsModal.scss';

function DepositTransactionsModal() {
  const dispatch = useDispatch();

  const deposit = useDeposit();

  const {
    data: transactions,
    fetchNextPage,
    isLoading,
  } = useDepositTransactions(deposit.data?.id ?? null);

  const handleDepositWithdrawRequestClick = () => {
    dispatch(recordGTMEvent('depositWithdrawRequestClick'));
  };

  return (
    <div className="Container Container--max-lg">
      <div className="Card Card--pop WindowModal WindowModal--fixed-height">
        <div className="WindowModal__header">
          <h4 className="WindowModal__header-title">
            <strong>예치금 내역</strong>
          </h4>
          <button
            className="WindowModal__header-close-btn"
            type="button"
            onClick={() => {
              dispatch(modalClose());
            }}
          />
        </div>
        <div className="WindowModal__content-wrapper">
          <div className="WindowModal__content PaymentListModal__content">
            <div className="space-6x box-4x">
              <div className="align-right space-4x">
                <button
                  className="TextBtn TextBtn--underline TextBtn--gray"
                  type="button"
                  onClick={handleDepositWithdrawRequestClick}
                >
                  예치금 환불 신청하기
                  <ArrowIcon direction="right" ml="2px" />
                </button>
              </div>
              <DepositTransactionList />
              {transactions && (
                <div className="DepositTransactionsModal__has-more-button">
                  <button
                    className="TextBtn TextBtn--gray TextBtn--underline"
                    data-testid="has-more-button"
                    type="button"
                    onClick={() => fetchNextPage()}
                  >
                    + 예치금 내역 더 보기
                  </button>
                </div>
              )}
              {isLoading && (
                <div
                  className="DepositTransactionsModal__spinner"
                  data-testid="fetching-deposit-transactions"
                >
                  <CenterLoadingSpinner size={20} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DepositTransactionsModal;
